import { Button, Card, Col, Container, Form, FormSelect, ListGroup, ListGroupItem, Row } from "shards-react";
import { useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useEffect } from "react";
import { connect } from "react-redux";
import ActionBar from "../../../components/common/ActionBar";
import { get_client_permission, save_client_permission } from "../../../redux/actions/client/clientPermission";

function ClientPermission({
    save_client_permission,
    get_client_permission,
    clientPermission,
}) {

    const [formData, setFormData] = useState({
        allowAllClientAdminForInvoice: 0,
        allowAllClientBillingForInvoice: 0,
    })
    const [formSubmitting, setForSubmitting] = useState(false);
    const history = useHistory();

    const onChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        if(formSubmitting) return;
        
        let formDataToSubmit = { ...formData };
        setForSubmitting(true);
        let saved = await save_client_permission(formDataToSubmit);
        
        if (saved) history.goBack();
        setForSubmitting(false)
    }

    let dropdownAdminValues = ['No, do not allow Admin Users to View Invoices', 'Yes, allow Admin Users to View Invoices']
    let dropdownBillingValues = ['No, do not allow Billing Users to View Invoices', 'Yes, allow Billing Users to View Invoices']
    let adminDropOption = dropdownAdminValues.map((x, i) => <option key={i} value={i}>{x}</option> );
    let billingDropOption = dropdownBillingValues.map((x, i) => <option key={i} value={i}>{x}</option> );

    const getFormData = (payComponent) => {
        return {
            allowAllClientAdminForInvoice: payComponent.allowAllClientAdminForInvoice || formData.allowAllClientAdminForInvoice,
            allowAllClientBillingForInvoice: payComponent.allowAllClientBillingForInvoice || formData.allowAllClientBillingForInvoice,
        }
    }
    useEffect(() => {
        setFormData({ ...getFormData(clientPermission) })
    }, [clientPermission])

    useEffect(() => {
        get_client_permission();
    }, [])
    return (
        <>
            <Container fluid className="main-content-container p-0">
                <Form onSubmit={onSubmit}>
                    <ActionBar id="newPayComponent" className="mb-4">
                        <Button className="my-2 py-2 mx-1" size="sm" theme="accent" name="save">
                            Save
                        </Button>
                        <Button onClick={e => history.goBack()} className="my-2 py-2 mx-1" size="sm" theme="accent">
                            Cancel
                        </Button>
                    </ActionBar>
                    <div className="px-3 ">
                        <Card small className="mb-4 w-100">
                            {/* <h4 className="m-0 section-title idStyle">Ref# {formData.payComponentRefNum}</h4> */}
                            <ListGroup flush>
                                <ListGroupItem className="border-card p-3">
                                    <Row>
                                            <Col>
                                                <label><b> Invoice Viewing Permissions </b></label>
                                            </Col>
                                        </Row>
                                        <Row className="pl-3 pr-2"> 
                                            <Col lg="3" className="form-group m-0 p-2">
                                                <label htmlFor="allowAllClientAdminForInvoice">Allow Admin Users to View Invoices</label>
                                                <span aria-hidden="true" className="required"> *</span>
                                                <FormSelect
                                                    required={true}
                                                    value={formData.allowAllClientAdminForInvoice}
                                                    id="allowAllClientAdminForInvoice"
                                                    name='allowAllClientAdminForInvoice'
                                                    onChange={onChange}
                                                    className='d-block'>
                                                    <option value=''> Select Allow Admin Users to View Invoices </option>
                                                    { adminDropOption }
                                                </FormSelect>
                                            </Col>
        
                                            <Col lg="3" className="form-group m-0 p-2">
                                                <label htmlFor="allowAllClientBillingForInvoice">
                                                    Allow Billing Users to View Invoices
                                                </label>
                                                <span aria-hidden="true" className="required"> *</span>
                                                <FormSelect
                                                    required={true}
                                                    value={formData.allowAllClientBillingForInvoice}
                                                    id="allowAllClientBillingForInvoice"
                                                    name='allowAllClientBillingForInvoice'
                                                    onChange={onChange}
                                                    className='d-block'>
                                                    <option value=''> Select Allow Admin Users to View Invoices </option>
                                                    { billingDropOption }
                                                </FormSelect>
                                            </Col>
                                        </Row>
                                </ListGroupItem>
                            </ListGroup>
                        </Card>
                    </div>
                </Form>
            </Container>
        </>
    )
}
const mapStateToProps = (state) => {
    return {
        clientPermission: state.clientPermission.clientPermission
    }
}

export default connect(mapStateToProps, {
    save_client_permission,
    get_client_permission,
})(ClientPermission)